// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XzOdDJCC_Q25otM9Tb3_{padding:0 24px 16px 24px}.jzJr1Om_tvPdZ9TcdoVp{padding:0 24px 20px 24px}`, "",{"version":3,"sources":["webpack://./src/widgets/Flow/ui/FlowDeleteAction/ui/styles.module.scss"],"names":[],"mappings":"AAEA,sBACE,wBAAA,CAEF,sBACE,wBAAA","sourcesContent":["@import 'app/styles/breakpoints';\n\n.alert {\n  padding: 0 24px 16px 24px;\n}\n.wrapOptions {\n  padding: 0 24px 20px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `XzOdDJCC_Q25otM9Tb3_`,
	"wrapOptions": `jzJr1Om_tvPdZ9TcdoVp`
};
export default ___CSS_LOADER_EXPORT___;
